// extracted by mini-css-extract-plugin
export var active = "_h5-2";
export var recordingDot = "_h5-1";
export var recordingIndicator = "_h5-0";